module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.columns.length > 0) ? _c('div', {
    ref: "table",
    class: [_vm.prefixCls, _vm.tableClass]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHeader),
      expression: "showHeader"
    }],
    ref: "header-wrapper",
    class: (_vm.prefixCls + "__header-wrapper"),
    on: {
      "mousewheel": function($event) {
        return _vm.handleEvent('header', $event)
      }
    }
  }, [_c('table-header', {
    ref: "table-header"
  })], 1), _vm._v(" "), _c('div', {
    ref: "body-wrapper",
    class: (_vm.prefixCls + "__body-wrapper"),
    style: (_vm.bodyWrapperStyle),
    on: {
      "scroll": function($event) {
        return _vm.handleEvent('body', $event)
      }
    }
  }, [_c('table-body', {
    ref: "table-body",
    class: _vm.bodyClass
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSummary && _vm.data.length > 0),
      expression: "showSummary && data.length > 0"
    }],
    ref: "footer-wrapper",
    class: (_vm.prefixCls + "__footer-wrapper"),
    on: {
      "mousewheel": function($event) {
        return _vm.handleEvent('footer', $event)
      }
    }
  }, [_c('table-footer', {
    ref: "table-footer"
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e551df5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Table/Table.vue
// module id = 63
// module chunks = 0